import { FC, useCallback } from 'react'

import { AnnualReviews } from 'commons/types/DTO/bank/alerts/annualReviews'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'

import { columns } from './columns'
import { Filter } from './components'

export const AnnualReviewsTable: FC = () => {
  const { data, isTableLoading, onPageChange } = useAlertsContext()

  const {
    form: { annualReviewsPage, annualReviewsSize },
    annualReviews,
    annualReviewsTotalCount
  } = data

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'annualReviews')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="Annual Reviews" anchor="annual-review">
      <Layer rounded shadowed stretch>
        <Filter />
        <Table<AnnualReviews>
          dataQa={TableDataQa.BP_ALERTS_ANNUAL_REVIEWS}
          columns={columns()}
          dataSource={annualReviews.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('annualReviews')}
          pagination={{
            page: annualReviewsPage || 1,
            size: annualReviewsSize || 10,
            onChange: handlePageChange,
            total: annualReviewsTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
}
